(() => {
  'use strict';
  const root = document.documentElement;
  if (root.hasAttribute('data-rudca-inbox-compact-ready')) return;
  root.setAttribute('data-rudca-inbox-compact-ready', '');
  const viewport = window.visualViewport;
  let baselineWidth = window.innerWidth;
  let baselineHeight = window.innerHeight;
  let frame = 0;

  const sync = () => {
    frame = 0;
    const width = window.innerWidth;
    const height = window.innerHeight;
    // A rotated/resized viewport establishes a new baseline. A keyboard usually
    // changes only height, including browsers that resize the layout viewport.
    if (Math.abs(width - baselineWidth) > 48) {
      baselineWidth = width;
      baselineHeight = height;
    } else {
      baselineHeight = Math.max(baselineHeight, height);
    }
    const visibleHeight = viewport ? viewport.height : height;
    const zoomed = viewport && Math.abs(viewport.scale - 1) > 0.02;
    const reducedViewport = Math.max(height, baselineHeight) - visibleHeight > 120;
    root.toggleAttribute('data-rudca-inbox-compact', !zoomed && !reducedViewport);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  viewport?.addEventListener('resize', schedule, { passive: true });
  sync();
})();
